import React from 'react';
import './about.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faCalendarDays } from '@fortawesome/free-solid-svg-icons';

const socials = [
  { href: 'https://github.com/siddiqodiq', icon: faGithub, label: 'Visit my GitHub profile' },
  { href: 'https://www.linkedin.com/in/odiq/', icon: faLinkedin, label: 'Connect on LinkedIn' },
  { href: 'https://www.instagram.com/siddiq_odiq/', icon: faInstagram, label: 'Follow me on Instagram' },
  { href: 'mailto:siddiqodiq@gmail.com', icon: faEnvelope, label: 'Send me an email' }
];

const About = () => {
  const profileImage = require('../../assets/image.webp');
  return (
    <section className="about section" id="about">
      <div className="about__container container">
        <div className="about__text">
          <span className="about__eyebrow">About Me</span>
          <h1 className="about__headline">Hello, I'm Syubbanul Siddiq</h1>
          <p className="about__paragraph">
            I am a security engineer specializing in web security. I conduct security assessments of applications and infrastructure to identify vulnerabilities, and I build and maintain security solutions that keep teams safe.
          </p>
          <p className="about__paragraph">
            I am also passionate about exploring and applying Artificial Intelligence. Several of my cybersecurity tools and software products are integrated with AI.
          </p>
          <p className="about__paragraph">
            I enjoy collaborating with teams across time zones and always look forward to new challenges.
            Let's talk if you have an idea that could use a curious mind.
          </p>

          <div className="about__actions">
            <a
              href="mailto:siddiqodiq@gmail.com"
              className="button button--flex about__cta"
              aria-label="Discuss your project via email"
            >
              <FontAwesomeIcon icon={faCalendarDays} />
              <span>Let's discuss your idea</span>
            </a>
          </div>
        </div>

        <div className="about__media">
          <div className="about__image-wrapper">
            <img src={profileImage} alt="Syubbanul Siddiq" className="about__image" />
          </div>

          <div className="about__socials">
            {socials.map((item) => (
              <a
                key={item.label}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className="about__social"
                aria-label={item.label}
              >
                <FontAwesomeIcon icon={item.icon} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;